/**
 * Propina para el repartidor (spec 2026-09-12-delivery-propina-repartidor-design.md).
 *
 * Módulo NORMAL (sin "use server") a propósito: lo importan el checkout del
 * cliente (presets, validación del input) y los schemas zod de /session y
 * /api/online-orders (tope). Un solo origen para el rango evita que la UI
 * acepte un monto que el servidor rechaza — o al revés.
 *
 * Todo en CENTAVOS enteros. La propina nunca se grava ni se grossea.
 */
export const DRIVER_TIP_PRESETS_CENTS = [200, 300, 500] as const
export const DRIVER_TIP_MIN_CENTS = 100
export const DRIVER_TIP_MAX_CENTS = 5000

export function isValidDriverTipCents(v: unknown): v is number {
  return (
    typeof v === "number" &&
    Number.isInteger(v) &&
    v >= DRIVER_TIP_MIN_CENTS &&
    v <= DRIVER_TIP_MAX_CENTS
  )
}

/**
 * "3", "3.5", "$4.25" → centavos. `null` si está vacío, mal formado, con más de
 * dos decimales o fuera del rango. Nunca lanza: es input del cliente.
 */
export function parseDriverTipInput(raw: string): number | null {
  const cleaned = raw.trim().replace(/^\$/, "")
  if (!/^\d+(\.\d{1,2})?$/.test(cleaned)) return null
  const cents = Math.round(parseFloat(cleaned) * 100)
  return isValidDriverTipCents(cents) ? cents : null
}

export function formatDriverTipCents(cents: number): string {
  return `$${(cents / 100).toFixed(2)}`
}
